import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  FormText,
  Button,
  Card,
  Table,
} from "react-bootstrap";
import {
  IconUser,
  IconFileDescription,
  IconCalendarWeek,
  IconTrash,
  IconMail,
  IconPhone,
  IconCurrencyDollar,
} from "@tabler/icons-react";
import Select from "react-select";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, handleKeyDown } from "../../constant/_constant";
import DatePicker from "react-datepicker";
import { setContractName } from "../../redux/contrcatReducer";
import { useDispatch } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import moment from "moment";
import {
  differenceInYears,
  addYears,
  parseISO,
  isBefore,
  addMonths,
  differenceInMonths,
} from "date-fns";
import { toast } from "react-toastify";
function GeneralInformationForm({ isEditing, contract_id }) {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  const {
    data: fetchdata,
    isLoading,
    postData: fetchContract,
  } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

  const {
    data: ParentData,
    isLoadingData,
    postData: fetchParentData,
  } = usePostRequest(API_ENDPOINTS.GET_PARENT_CONTRACT);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   fetchContract();
  // }, []);

  useEffect(() => {
    fetchParentData();
  }, []);

  const [searchDebounces, setSearchDebounces] = useState({
    searchName: "",
  });

  const { data: fetchProject, postData: fetchProjectData } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_VEHICLE,
  );

  const {
    data: fetchdatas,
    isLoadings,
    postData: fetchRfq,
  } = usePostRequest(API_ENDPOINTS.GET_CUSTOMER_AUTOFILL);

  const {
    data: result,
    isLoading: resultLoading,
    postData: validateContractName,
  } = usePostRequest(API_ENDPOINTS.VALIDATE_CONTRACTNAME);

  const [suggestionData, setSuggestionData] = useState([]);

  const suggestionBoxRef = useRef(null);

  const contractVehicleSelected = watch("contractVehicle");
  // const dueDate = watch("dueDate");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionBoxRef.current &&
        !suggestionBoxRef.current.contains(event.target)
      ) {
        setSuggestionData(null);
        setSearchDebounces({ searchName: "" });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   if (fetchdata?.data && !contractVehicleSelected && !isEditing) {
  //     const selectedVehicle = fetchdata.data[0]?.id;
  //     setValue("contractVehicle", selectedVehicle);
  //   }

  //   if (fetchdata?.data) {
  //     const contractName = fetchdata.data.find(
  //       (vehicle) => vehicle.id == contractVehicleSelected,
  //     )?.name;
  //     if (contractName) {
  //       dispatch(setContractName(contractName));
  //     }
  //   }
  // }, [fetchdata, contractVehicleSelected, isEditing, setValue]);

  const handleDropdownValue = (vehicleId) => {
    return vehicleId || "";
  };

  // const CustomInput = ({ value, onClick }) => (
  //   <input
  //     className="form-control"
  //     type="text"
  //     value={value}
  //     placeholderText="Select a date"
  //     onClick={onClick}
  //     readOnly // Ensures text cannot be typed
  //     style={{ cursor: "pointer" }}
  //   />
  // );

  const selectContractVehicle = (vehicleId) => {
    setValue("vehicleId", vehicleId);
    if (vehicleId) {
      fetchProjectData(
        {
          contract_type_id: vehicleId,
        },
        onProjectDataSuccess,
      );
    }
  };

  const onProjectDataSuccess = (data) => {
    setValue(
      "contract_vehicle_type",
      data?.data?.contract_vehicle_type
        ? data?.data?.contract_vehicle_type
        : "",
    );
    setValue("organization_name", data?.data?.project?.organization_name || "");
    setValue("Order_Description", data?.data?.project?.brief || "");
    setValue("ordertype", data?.data?.project?.order_type || "");
    setValue("contractPocName", data?.data?.project?.point_of_contact?.name || "");
    setValue("contractPocEmail", data?.data?.project?.point_of_contact?.email || "");
    setValue("contractPocPhone", data?.data?.project?.point_of_contact?.phone || "");
    setValue(
        "project_duration",
        data?.data?.project?.project_duration ? data?.data?.project?.project_duration : null,
      );
    setValue(
      "order_Payment_Type",
      data?.data?.project?.order_payment_type || "",
    );

    setValue(
      "estimateddelivery",
      data?.data?.project?.estimated_delivery || "",
    );
    setValue("payment_terms", data?.data?.project?.payment_term || "");
    setValue("shipping_terms", data?.data?.project?.shipping_term || "");
    setValue(
      "payment_term_detail",
      data?.data?.project?.payment_term_detail || "",
    );
    setValue(
      "shipping_method_detail",
      data?.data?.project?.shipping_method_detail || "",
    );
    setValue("shipping_method", data?.data?.project?.shipping_method || "");
    setValue(
      "initial_consolidation",
      data?.data?.project?.initial_consolidation || "",
    );

    setValue("contractOfficerName", data?.data?.project?.rfqKo?.name || "");
    setValue("contractOfficerEmail", data?.data?.project?.rfqKo?.email || "");
    setValue("contractOfficerPhone", data?.data?.project?.rfqKo?.phone || "");
    setValue(
      "contractOfficerAddress",
      data?.data?.project?.rfqKo?.address || "",
    );
    setValue(
      "shippingCustomerName",
      data?.data?.project?.rfqShipping?.name || "",
    );
    setValue(
      "shippingCustomerEmail",
      data?.data?.project?.rfqShipping?.email || "",
    );
    setValue(
      "shippingCustomerPhone",
      data?.data?.project?.rfqShipping?.phone || "",
    );
    setValue(
      "shippingCustomerAddress",
      data?.data?.project?.rfqShipping?.address || "",
    );
    setValue(
      "BillingCustomerName",
      data?.data?.project?.rfqBilling?.name || "",
    );
    setValue(
      "BillingCustomerEmail",
      data?.data?.project?.rfqBilling?.email || "",
    );
    setValue(
      "BillingCustomerPhone",
      data?.data?.project?.rfqBilling?.phone || "",
    );
    setValue(
      "BillingCustomerAddress",
      data?.data?.project?.rfqBilling?.address || "",
    );
  };

  const options = [
    { value: "open", label: "Open" },
    { value: "budget-bound", label: "Budget-bound" },
    { value: "time-bound", label: "Time-bound" },
    { value: "product-bound", label: "Product-bound" },
  ];

  const selectedVehicleTypes = watch("contract_vehicle_type");

  const selectedOptions = options.filter((opt) =>
    selectedVehicleTypes?.split(",").includes(opt.value),
  );

  const {
    fields: customFields,
    append: appendField,
    remove: removeField,
  } = useFieldArray({
    control,
    name: "custom_fields",
  });

  const [fieldType, setFieldType] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [customFieldError, setCustomFieldError] = useState("");
  const [contractNameEd, setContractNameEd] = useState(null);

  const handleAddCustomField = () => {
    if (!fieldType || !fieldName.trim()) {
      setCustomFieldError("Both field type and name are required.");
      return;
    }

    appendField({
      type: fieldType,
      field_name: fieldName.trim(),
      value: "",
    });

    // Clear state
    setFieldName("");
    setFieldType("");
    setCustomFieldError("");
  };

  const handleCancelCustomField = () => {
    setFieldType("");
    setFieldName("");
  };

  const handleRemoveCustomField = (index) => {
    removeField(index);
  };

  const startDate = watch("start_date");

  // useEffect(() => {
  //   const start = watch("start_date");
  //   const end = watch("due_date");

  //   if (start && end) {
  //     const startDate = new Date(start);
  //     let endDate = new Date(end);

  //     // Enforce minimum 1 year difference
  //     const minDueDate = addYears(startDate, 1);

  //     if (isBefore(endDate, minDueDate)) {
  //       endDate = minDueDate;
  //       setValue("due_date", endDate, {
  //         shouldValidate: true,
  //         shouldDirty: true,
  //       });
  //     }

  //     const diffYears = differenceInYears(endDate, startDate);
  //     setValue("project_duration", diffYears, {
  //       shouldValidate: true,
  //       shouldDirty: true,
  //     });
  //   }
  // }, [watch("start_date"), watch("due_date")]);

  // useEffect(() => {
  //   const start = watch("start_date");
  //   const duration = Number(watch("project_duration"));

  //   if (start && duration) {
  //     const startDate = new Date(start);
  //     const safeDuration = Math.max(duration, 1); // Enforce minimum 1 year

  //     const calculatedEnd = addYears(startDate, safeDuration);

  //     setValue("due_date", calculatedEnd, {
  //       shouldValidate: true,
  //       shouldDirty: true,
  //     });
  //   }
  // }, [watch("start_date"), watch("project_duration")]);

  useEffect(() => {
    const start = watch("start_date");
    const end = watch("due_date");

    if (start && end) {
      const startDate = new Date(start);
      let endDate = new Date(end);

      const startYear = startDate.getFullYear();
      let endYear = endDate.getFullYear();

      // Enforce minimum 1 year difference
      if (endYear - startYear < 1) {
        endYear = startYear + 1;
        endDate.setFullYear(endYear);

        setValue("due_date", endDate, {
          shouldValidate: true,
          shouldDirty: true,
        });
      }

      const projectDuration = endYear - startYear;

      setValue("project_duration", projectDuration, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [watch("start_date"), watch("due_date")]);

  useEffect(() => {
    const start = watch("start_date");
    const duration = Number(watch("project_duration"));

    if (start && duration) {
      const startDate = new Date(start);
      const safeDuration = Math.max(duration, 1);

      const endDate = new Date(startDate);
      endDate.setFullYear(startDate.getFullYear() + safeDuration);

      setValue("due_date", endDate, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [watch("start_date"), watch("project_duration")]);

  // console.log("customFields", customFields);

  const handleSearchByName = (e) => {
    setSearchDebounces({ searchName: e.target.value });
  };

  useEffect(() => {
    if (searchDebounces?.searchName?.length > 0) {
      fetchRfq(
        {
          first_name:
            searchDebounces?.searchName?.length > 0
              ? searchDebounces?.searchName
              : undefined,
          module_type: "ORDER",
        },
        onSuggestionSuccessData,
      );
    }
  }, [searchDebounces]);

  const onSuggestionSuccessData = (data) => {
    setSuggestionData(data);
  };

  const handleSelectOrganization = (item) => {
    setValue("organization_name", item.display_name);

    setValue(
      "contractPocName",
      `${item?.first_name || ""} ${item?.last_name || ""}`,
    );
    setValue(
      "contractPocEmail",
      item?.primary_email ? item.primary_email.Address : "",
    );
    setValue(
      "contractPocPhone",
      item?.primary_phone ? item.primary_phone.FreeFormNumber : "",
    );

    setValue(
      "contractOfficerName",
      `${item?.first_name || ""} ${item?.last_name || ""}`,
    );
    setValue(
      "contractOfficerEmail",
      item?.primary_email ? item.primary_email.Address : "",
    );
    setValue(
      "contractOfficerPhone",
      item?.primary_phone ? item.primary_phone.FreeFormNumber : "",
    );
    setValue("contractOfficerAddress", item.address);

    setValue("shippingCustomerName", item?.shipping_name);
    setValue("shippingCustomerEmail", item?.shipping_email);
    setValue("shippingCustomerPhone", item?.shipping_phone);

    if (item?.shipping_address) {
      const address = item.shipping_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "") // Remove blank lines
        .join("\n");

      setValue("shippingCustomerAddress", formattedAddress);
    }

    setValue("BillingCustomerName", item?.billing_name);
    setValue("BillingCustomerEmail", item?.billing_email);
    setValue("BillingCustomerPhone", item?.billing_phone);

    if (item?.billing_address) {
      const address = item.billing_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "")
        .join("\n");
      setValue("BillingCustomerAddress", formattedAddress);
    }
    setSuggestionData(null);
  };

  const onValidateError = (data) => {
    toast.error(
      data?.errors?.name?.message ||
        "Contract name already exists, please choose another name",
    );
    if (contract_id) {
      setValue("opportunityName", contractNameEd);
    } else {
      setValue("opportunityName", "");
    }
  };

  useEffect(() => {
    if (contract_id) {
      const contractNameEdit = watch("opportunityName");
      setContractNameEd(contractNameEdit);
    } else {
      return;
    }
  }, [contract_id]);

  const onValidateSuccess = (data) => {
    console.log("validate success", data);
  };

  const validateContract = (name) => {
    if (name && name.trim().length > 0) {
      const trimmedName = name.trim();

      const payload = contract_id
        ? {
            name: trimmedName,
            contract_type_id: contract_id,
          }
        : {
            name: trimmedName,
          };

      validateContractName(payload, onValidateSuccess, onValidateError);
    }
  };

  const selectedContractVehicleType = watch("contract_vehicle_type");

  return (
    <>
      <Row className="">
        <Col lg={3} md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Name</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                {...register("opportunityName")}
                placeholder="Name"
                autoComplete="off"
                onBlur={(e) => validateContract(e.target.value)}
              />
            </InputGroup>
            {errors.opportunityName && (
              <span className="text-danger">
                {errors.opportunityName.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col lg={3} md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">ID</Form.Label>
            <Form.Control
              {...register("rfqId")}
              placeholder="Enter N/A"
              defaultValue={"N/A"}
              disabled={isEditing}
            />
            {errors.rfqId && (
              <span className="text-danger">{errors.rfqId.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col lg={3} md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Abbreviation</Form.Label>
            <InputGroup>
              <Form.Control {...register("code")} placeholder="Abbreviation" />
            </InputGroup>
            {errors.code && (
              <span className="text-danger">{errors.code.message}</span>
            )}
          </Form.Group>
        </Col>
        {/* <Col lg={2} md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Contract Vehicle</Form.Label>
            <InputGroup>
              <Form.Select
                {...register("contractVehicle")}
                disabled={isEditing}
                value={handleDropdownValue(contractVehicleSelected)}
              >
                <option>Select a contract vehicle </option>
                {fetchdata?.data?.map((vehicle, index) => (
                  <option key={index} value={vehicle.id}>
                    {vehicle.name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            {errors.contractVehicle && (
              <span className="text-danger">
                {errors.contractVehicle.message}
              </span>
            )}
          </Form.Group>
        </Col> */}
        <Col lg={3} md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Customer Name</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                {...register("organization_name")}
                placeholder="Enter agency Name"
                onChange={handleSearchByName}
              />
            </InputGroup>
            <div>
              {suggestionData?.data?.length > 0 &&
                searchDebounces?.searchName?.length > 0 && (
                  <div className="suggestions_box" ref={suggestionBoxRef}>
                    <div className="table-responsive">
                      <Table>
                        <tbody>
                          {suggestionData?.data?.map((item, index) => (
                            <tr
                              key={index}
                              onClick={() => handleSelectOrganization(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <td>{item?.display_name}</td>
                              <td>{`${item?.first_name || ""}`}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                )}
            </div>
            {errors.organization_name && (
              <span className="text-danger">
                {errors.organization_name.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="">Parent Contract Vehicle</Form.Label>
            <InputGroup>
              <Form.Select
                {...register("contractVehicle")}
                // disabled={isEditing}
                value={contractVehicleSelected || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setValue("contractVehicle", selectedValue);
                  selectContractVehicle(selectedValue);
                }}
              >
                <option>Select a contract vehicle</option>
                {ParentData?.data?.map((vehicle, index) => (
                  <option key={index} value={vehicle.id}>
                    {vehicle.name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            {errors.contractVehicle && (
              <span className="text-danger">
                {errors.contractVehicle.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col lg={4} md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="">Order Type</Form.Label>
            <InputGroup>
              <Form.Select {...register("ordertype")}>
                <option value="DS">Dropship</option>
                <option value="CRK">Consolidate / Repack</option>
                <option value="M">Manufacturing</option>
                <option value="KIT">Kit</option>
                <option value="S">Stock</option>
              </Form.Select>
            </InputGroup>
            {errors.ordertype && (
              <span className="text-danger">{errors.ordertype.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col lg={4} md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="">Order Payment Type</Form.Label>
            <InputGroup>
              <Form.Select {...register("order_Payment_Type")}>
                <option value="">Select a type</option>
                <option value="invoiced">Invoiced</option>
                <option value="pre-paid">Pre-Paid</option>
                <option value="post-paid">Post-Paid</option>
              </Form.Select>
            </InputGroup>
            {errors.order_Payment_Type && (
              <span className="text-danger">
                {errors.order_Payment_Type.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconFileDescription stroke={1} />
              </InputGroup.Text>
              <Form.Control
                as="textarea"
                {...register("Opportunity_Description")}
                placeholder="Enter Description"
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
              />
            </InputGroup>
            {errors.Opportunity_Description && (
              <span className="text-danger">
                {errors.Opportunity_Description.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        {/* <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label">Email(s)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Email"
              {...register("emails")}
            />
            <Form.Text>
              Please enter the email as it apppears on the Quote or Invoice,
              separate the emails with commas like -{" "}
              <span className="fw-semibold text-primary">
                customer@aspettoinc.com, xyz@companyname.com
              </span>
            </Form.Text>
          </Form.Group>
        </Col> */}

        <Col xs={6} className="mb-3">
          <Form.Group className="mb-3">
            <Form.Label className="required">Contract Vehicle Type</Form.Label>
            <Controller
              name="contract_vehicle_type"
              control={control}
              render={({ field }) => (
                <Select
                  isMulti
                  value={selectedOptions}
                  options={options}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                  className="basic-multi-select"
                  onChange={(selectedOptions) => {
                    const valuesString = selectedOptions
                      .map((o) => o.value)
                      .join(",");
                    field.onChange(valuesString);
                  }}
                />
              )}
            />
            {errors.contract_vehicle_type && (
              <span className="text-danger">
                {errors.contract_vehicle_type.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label className="">Duration (in years)</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Form.Control
                {...register("project_duration")}
                placeholder="Duration"
                disabled={true}
                type="number"
                onKeyDown={handleKeyDown}
                step="1"
                min="1"
                // defaultValue={1}
              />
            </InputGroup>
            {errors.project_duration && (
              <span className="text-danger">
                {errors.project_duration.message}
              </span>
            )}
          </Form.Group>
        </Col>
        {selectedContractVehicleType?.includes("budget-bound") && (
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label className="required">Budget</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconCurrencyDollar stroke={2} />
                </InputGroup.Text>
                <Form.Control
                  {...register("project_budget")}
                  placeholder="Project Budget"
                  type="number"
                  onKeyDown={handleKeyDown}
                />
              </InputGroup>
              {errors.project_budget && (
                <span className="text-danger">
                  {errors.project_budget.message}
                </span>
              )}
            </Form.Group>
          </Col>
        )}
      </Row>
      <Row className="">
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Date Created</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Controller
                name="publishedDate"
                control={control}
                defaultValue={new Date()}
                rules={{ required: "Published date is required" }}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="MM/dd/yyyy"
                    // minDate={new Date()}
                    placeholderText="Select Date"
                    className="form-control required"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                    showYearDropdown
                    showMonthDropdown
                  />
                )}
              />
            </InputGroup>
            {errors.publishedDate && (
              <span className="text-danger">
                {errors.publishedDate.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Date Starts</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Controller
                name="start_date"
                control={control}
                defaultValue={new Date()}
                rules={{ required: "Start date is required" }}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="MM/dd/yyyy"
                    // minDate={new Date()}
                    placeholderText="Select Date"
                    className="form-control required"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                    showYearDropdown
                    showMonthDropdown
                  />
                )}
              />
            </InputGroup>
            {errors.start_date && (
              <span className="text-danger">{errors.start_date.message}</span>
            )}
          </Form.Group>
        </Col>
        {selectedContractVehicleType?.includes("time-bound") && (
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label className="required">Date Ends</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconCalendarWeek stroke={1} />
                </InputGroup.Text>
                <Controller
                  name="due_date"
                  control={control}
                  // rules={{ required: "Date Ends date is required" }}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      selected={field.value ? new Date(field.value) : null}
                      onChange={(date) => field.onChange(date)}
                      dateFormat="MM/dd/yyyy"
                      // minDate={startDate ? addYears(new Date(startDate), 1) : addYears(new Date(), 1)}
                      // minDate={addYears(new Date(startDate), 1)}
                      // minDate={new Date()}
                      placeholderText="Select Date"
                      className="form-control required"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                      showYearDropdown
                      showMonthDropdown
                    />
                  )}
                />
              </InputGroup>
              {errors.due_date && (
                <span className="text-danger">{errors.due_date.message}</span>
              )}
            </Form.Group>
          </Col>
        )}

        {customFields.length > 0 &&
          customFields.map((field, index) => (
            <Col xs={4} key={index}>
              <Form.Group className="mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <Form.Label>{field.field_name}</Form.Label>
                  <span
                    className="trash_icon"
                    onClick={() => handleRemoveCustomField(index)}
                  >
                    <IconTrash size={20} stroke={1} />
                  </span>
                </div>
                {field.type === "number" && (
                  <Form.Control
                    type="text"
                    onKeyDown={handleKeyDown}
                    placeholder={`Enter ${field.field_name}`}
                    {...register(`custom_fields[${index}].value`)}
                    disabled={true}
                  />
                )}
                {field.type === "text" && (
                  <Form.Control
                    type="text"
                    placeholder={`Enter ${field.field_name}`}
                    {...register(`custom_fields[${index}].value`)}
                    disabled={true}
                  />
                )}
                {field.type === "date" && (
                  <InputGroup>
                    <InputGroup.Text>
                      <IconCalendarWeek stroke={1} />
                    </InputGroup.Text>
                    <Controller
                      name={`custom_fields[${index}].value`}
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          disabled={true}
                          {...field}
                          selected={field.value ? new Date(field.value) : null}
                          onChange={(date) => field.onChange(date)}
                          dateFormat="MM/dd/yyyy"
                          // minDate={new Date()}
                          placeholderText={`Select ${
                            field.field_name || "Date"
                          }`}
                          className="form-control"
                          showYearDropdown
                          showMonthDropdown
                        />
                      )}
                    />
                  </InputGroup>
                )}
                {errors.custom_fields?.[index]?.value && (
                  <span className="text-danger">
                    {errors.custom_fields[index].value.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          ))}
      </Row>
      <Row>
        <Col md={9}>
          <Form.Group className="mb-3">
            <Form.Label>Custom Fields</Form.Label>
            <InputGroup className="custom-dropdown mb-3">
              <DropdownButton
                variant="outline-secondary"
                title={fieldType || "Select Type"}
                id="input-group-dropdown-1"
                onSelect={(type) => setFieldType(type)}
              >
                <Dropdown.Item eventKey="number">Number</Dropdown.Item>
                <Dropdown.Item eventKey="text">Text</Dropdown.Item>
                <Dropdown.Item eventKey="date">Date</Dropdown.Item>
              </DropdownButton>
              <Form.Control
                aria-label="Field Name"
                value={fieldName}
                onChange={(e) => setFieldName(e.target.value)}
                placeholder="Enter field name"
              />
            </InputGroup>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Label className="form-label d-none d-sm-block">
            &nbsp;
          </Form.Label>
          <div className="d-flex gap-2">
            <Button
              className="flex-grow-1"
              onClick={handleAddCustomField}
              variant="primary"
            >
              Add
            </Button>
            <Button
              className="flex-grow-1"
              variant="outline-secondary"
              onClick={handleCancelCustomField}
            >
              Cancel
            </Button>
          </div>
        </Col>
      </Row>
      {customFieldError && (
        <span className="text-danger mt-1">{customFieldError}</span>
      )}

      <Card className="mb-3">
        <Card.Header className="card_header">
          <IconFileDescription /> Contract Poc (Point of contact)
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Full name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("contractPocName")}
                    placeholder="Enter Full Name"
                  />
                </InputGroup>
                {errors.contractPocName && (
                  <span className="text-danger">
                    {errors.contractPocName.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("contractPocEmail")}
                    type="email"
                    placeholder="Enter Email"
                  />
                </InputGroup>
                {errors.contractPocEmail && (
                  <span className="text-danger">
                    {errors.contractPocEmail.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="contractPocPhone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.contractPocPhone && (
                  <span className="text-danger">
                    {errors.contractPocPhone.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}
export default GeneralInformationForm;
